module.exports = __webpack_public_path__ + "static/media/middle-logo.0b1ce9c6.png";